import { Component, OnInit, Input } from '@angular/core';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { SemCreativeCardV1Component } from '../sem-creative-card-v1/sem-creative-card-v1.component';
import { EmitterService } from '../../../../core/utility/services/emitter.service';
import { EVENT_EMITTERS } from '../../../analytics/constants/analytics.constants';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { UtilityService } from '../../../../core/utility/services/utility.service';

@Component({
	selector: 'app-sem-creative-v7',
	templateUrl: './sem-creative-v7.component.html',
	styleUrls: ['./sem-creative-v7.component.css']
})
export class SemCreativeV7Component extends SemCreativeCardV1Component implements OnInit {
	@Input() metricsarray: any;
	@Input() sectionclass: any;
	public decodedMetrics: any;
	public immutableMetrics: any;
	public downloadIcon: string = '../../../../../assets/images/Download_Icon_R7.svg';

	constructor(protected analyticsService: AnalyticsService, protected analyticsDataModel: AnalyticsDataModel) {
		super(analyticsService);
		this.reloadSubscription = EmitterService.get(EVENT_EMITTERS.RELOAD).subscribe((response: any) => {
			this.processMetricsArray();
			this.requestData();
		});
	}

	ngOnInit() {
		super.ngOnInit();
		this.decodedMetrics = JSON.parse(decodeURI(this.metricsarray));
		this.immutableMetrics = JSON.parse(decodeURI(this.metricsarray));
		this.processMetricsArray();
		this.downloadIcon = this.analyticsDataModel.config.downloadIcon
			? this.analyticsDataModel.config.downloadIcon
			: this.downloadIcon;
	}

	processMetricsArray() {
		const dateSet = {
			startDate: this.analyticsDataModel.startDate,
			endDate: this.analyticsDataModel.endDate,
			depricatedDate: this.analyticsDataModel.depricatedDate,
			goLiveDate: this.analyticsDataModel.goLiveDate
		};
		this.decodedMetrics = UtilityService.checkForVisibilityPermissions(this.immutableMetrics, dateSet);
	}
}
